export enum civiliteEnum {
	homme = 221310000,
	femme = 221310001
}

export enum civiliteStringEnum {
	homme = 'M',
	femme = 'Mme'
}